'use strict';

/**
 * Header utilities module
 * Provides shared header-related functionality
 */

const $headerBanner = $('.header-banner');
const $navigation = $('.navigation');
const $siteHeader = $('.site-header');

/**
 * Checks if the immersive header mode is enabled.
 * @returns {boolean} return true if immersive header mode is enabled
 */
function isModeImmersive() {
    return $siteHeader.attr('mode-header') === 'immersive';
}

/**
 * Switch theme
 * @param {boolean} shouldSwitchTheme Whether to switch the theme
 */
function switchHeaderTheme(shouldSwitchTheme) {
    $siteHeader.attr(
        'data-header-theme-switch',
        shouldSwitchTheme ? 'on' : 'off'
    );
}

/**
 * Force header theme to off.
 */
function switchHeaderThemeOff() {
    $siteHeader.attr('data-header-theme-switch', 'off');
}

/**
 * Force header theme to on.
 */
function switchHeaderThemeOn() {
    $siteHeader.attr('data-header-theme-switch', 'on');
}

/**
 * Applies immersive header mode when enabled.
 * @param {boolean} isSticky Whether header is in sticky state
 */
function updateHeaderTheme(isSticky) {
    if (!isModeImmersive()) {
        switchHeaderThemeOff();
    } else {
        switchHeaderTheme(!isSticky);
    }
}

/**
 * Checks if the user has scrolled past the header banner.
 * @returns {boolean} true if scroll past header
 */
function isScrollPastHeader() {
    return $(window).scrollTop() > $headerBanner.height();
}

/**
 * Get the navigation element
 * @returns {jQuery} navigation element
 */
function getNavigation() {
    return $navigation;
}

/**
 * Toggle sticky-top class on navigation based on scroll position
 */
function updateStickyTop() {
    $navigation.toggleClass('sticky-top', isScrollPastHeader());
}

module.exports = {
    isModeImmersive,
    switchHeaderTheme,
    switchHeaderThemeOff,
    switchHeaderThemeOn,
    updateHeaderTheme,
    isScrollPastHeader,
    getNavigation,
    updateStickyTop
};
